import React, { useState } from 'react'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { message } from 'antd'
import _ from 'lodash'
import {
  Div, H4, Button, P, Icon, Loading,
} from 'konsys-ui'
import { BANKS, WAREHOUSES, INVENTORY } from '../../../constants/graph/query'
import {
  InputWithLabel, TextareaWithLabel, Select, ComponentWithLabelLarge,
} from '../../../components/common'
import { theme } from '../../../styles/_variables'
import { TRANSFER_STOCK } from '../../../constants/graph/mutation'
import { verifyFields } from '../../../utils/util-services'
import history from '../../../history'
import { TRANSPORT_WAREHOUSE_ID } from '../constants'

const InventoryOption = ({ option, props }) => {
  const [doUpdate, { loading }] = useMutation(TRANSFER_STOCK)
  const { data, loading: warehousesLoading } = useQuery(WAREHOUSES)
  const [sourceId, setSourseId] = useState()
  const [destinationId, setDestinationId] = useState()
  const [itemId] = useState(option.id)
  const [quantityChange, setQuantityChange] = useState()
  const [reason, setReason] = useState()

  return (
    <Div style={{ border: `1px solid ${theme.color.lightBlue}`, borderRadius: 5, background: theme.color.veryLightBlue }} margin='16px 0' padding='16px' display='flex' flexDirection='column'>
      <P bold>{option.variantName}</P>
      <Div display='flex' alignItems='center' justifyContent='center'>
        <ComponentWithLabelLarge margin='8px 0' width='80%' title={{ text: 'คลังต้นทาง' }}>
          <Select
            style={{ width: '100%' }}
            onChange={value => setSourseId(value)}
            options={
              _.remove(_.cloneDeep(option.stockLocation), o => o.warehouse.id !== destinationId && o.warehouse.id !== TRANSPORT_WAREHOUSE_ID).map(v => ({ text: v.warehouse.warehouseName, value: v.warehouse.id }))
            }
          />
        </ComponentWithLabelLarge>
        <Icon icon='fas fa-chevron-double-right' width='100%' margin='16px 16px 0'/>
        <ComponentWithLabelLarge margin='8px 0' width='80%' title={{ text: 'คลังปลายทาง' }}>
          <Select
            style={{ width: '100%' }}
            onChange={value => setDestinationId(value)}
            loading={warehousesLoading}
            options={
              warehousesLoading ? [] : _.remove(_.cloneDeep(data.warehouseList.data.list), o => o.id !== sourceId && o.id !== TRANSPORT_WAREHOUSE_ID).map(v => ({ text: v.warehouseName, value: v.id }))
            }
          />
        </ComponentWithLabelLarge>
        <InputWithLabel
          width='50%'
          margin='8px 0 8px 16px'
          input={{
            width: '100%',
            placeholder: 'กรอกจำนวนใหม่',
            state: 'default',
            rule: { type: 'int' },
          }}
          onChange={e => setQuantityChange(e.target.value)}
          title={{ text: 'จำนวนที่ย้าย' }}
        />
      </Div>
      <TextareaWithLabel
        width='100%'
        title={{
          text: 'เหตุผล',
        }}
        textarea={{
          style: { width: '100%' },
          rows: 5,
          onChange: e => setReason(e.target.value),
        }}
      />
      <Button
        style={{ alignSelf: 'flex-end' }}
        rightIcon
        inverse
        small
        icon='fal fa-angle-right'
        text='ยืนยัน'
        disabled={
          loading
          || verifyFields(
            {},
            [
              sourceId,
              destinationId,
              itemId,
              parseInt(quantityChange, 10),
            ],
            true,
          )
        }
        loading={loading}
        onClick={() => {
          doUpdate({
            variables: {
              sourceId,
              destinationId,
              itemId,
              quantityChange: parseInt(quantityChange, 10),
              reason,
            },
          }).then((resp) => {
            if (resp.data.transferStock.success) {
              message.success(resp.data.transferStock.message)
              history.push({
                pathname: `/inventory/view/${props.match.params.id}`,
              })
            } else message.error(resp.data.transferStock.message)
          })
        }}
      />
    </Div>
  )
}

export default ({ props }) => {
  const { loading: infoLoading, data: infoData, error: infoError } = useQuery(INVENTORY, { variables: { id: parseInt(props.match.params.id, 10) } })
  if (infoLoading && _.isUndefined(infoData)) return <Loading center='true' />
  const { data } = infoData.inventoryInfo
  return (
    <Div>
    <Div margin='16px 0'>
      <H4 bold>ย้ายคลัง</H4>
      <Div>
        {
          data.inventoryOptions.map(v => (
            <InventoryOption key={v.id} option={v} props={props}/>
          ))
        }
      </Div>
    </Div>
  </Div>
  )
}
